module.exports = {
    //baseUrl: 'https://customerapi.livefacetof.com', // 正式项目地址
    // wsurl: 'wss://customerapi.livefacetof.com/staff',
    baseUrl: 'https://coral-imapi.jinkunzs.com',
    wsurl: 'wss://coral-imapi.jinkunzs.com/staff',
}